import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { TranscribeJob } from 'server/shared/models/transcribeJob';

@Component({
  selector: 'app-transcribe-job-list-item-details-table',
  templateUrl: './transcribe-job-list-item-details-table.component.html',
  styleUrls: ['./transcribe-job-list-item-details-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TranscribeJobListItemDetailsTableComponent {
  transcribeJob$ = new BehaviorSubject<TranscribeJob | undefined>(undefined);
  @Input() set transcribeJob(transcribeJob: TranscribeJob | undefined) {
    this.transcribeJob$.next(transcribeJob);
  }
  get transcribeJob(): TranscribeJob | undefined {
    return this.transcribeJob$.getValue();
  }

  @Input() bookedAtInfo?: string;
  @Input() cancelledAtInfo?: string;

  constructor() {}
}
